import { Component } from '@angular/core';
import Swal from 'sweetalert2';
import { ActivatedRoute } from '@angular/router';
import { selfcreditService } from '../../self-credit/self-credit.service';

@Component({
  selector: 'app-cancel-request',
  templateUrl: './cancel-request.component.html',
  styleUrls: ['./cancel-request.component.scss']
})
export class CancelRequestComponent {
  constructor(
    public service: selfcreditService,
    private route: ActivatedRoute) {
  }
  id: string;

  ngOnInit(): void {
    this.service.CancelRequest(Number(this.route.snapshot.paramMap.get('id'))).subscribe((reps:any) =>{
        Swal.fire('',reps.success ? reps.data : reps.error,reps.success ? 'success' : 'error').then(resp2 => {})
    },error => {
      Swal.fire({
        icon: 'error',
        text: 'No pudimos realizar el registro, intenta nuevamente'
      })      
    })

  }
}
